module.exports = __webpack_public_path__ + "assets/52428fbaa98eae1779a886840da2c2f6.png";